import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setComments, setLoading, setPageAmount } from "../../repository/slice";

function* getCommentsWorker({ payload }: any): SagaIterator {
  const { id, type, limit, offset = 0 } = payload;
  const url =
    type === "document"
      ? `/api/admin/comments/documents/${id}`
      : `/api/admin/comments/announcements/${id}`;

  try {
    yield put(setLoading(true));
    const { data, message, isError }: IResponse<any> = yield call(
      requester.get,
      url,
      {
        limit,
        offset,
      }
    );

    if (isError) {
      console.error(message);
    } else {
      yield put(setComments(data.rows));
      yield put(setPageAmount(data.count));
    }
  } catch (error) {
    console.error("getCommentsWorker: ", error);
  } finally {
    yield put(setLoading(false));
  }
}

export function* getCommentsWatcher() {
  yield takeLatest("@saga/GET_COMMENTS", getCommentsWorker);
}
